/**
 * This is used to create a normalized value object that contains information on if it allready exists in the DB or if it was generated.
 */
export class NormalizedValue<T> {
    public value: string | null;

    public exists: boolean = false;

    public generated: boolean = false;

    public id?: number;

    public src: T | null = null;

    /**
     * This is set, if the generated flag is set to true, but the value is a predefined value that should be autogenerated.
     * @remarks This only works if the generated is set to true.
     */
    public defaultGenerated?: boolean;

    /**
     * The constructor for the NormalizedValue class.
     * @param value
     * @param exists
     * @param generated
     * @param id
     * @param src
     */
    public constructor(value: string | null, exists: boolean, generated: boolean, id?: number, src: T | null = null) {
        this.value = value;
        this.exists = exists;
        this.generated = generated;
        this.id = id;
        this.src = src;
    }
}
